/**
 * Wrapper component that searches for query params in URL and attaches them to Redux store
 */
import React, { Component } from 'react';
import {connect} from 'react-redux'
import { storeQueryParams } from './actions/query-consumer';

export function QueryConsumer(WrappedComponent) {
  class QueryConsumer extends Component {
    constructor(props) {
      super(props);
      const { storeParams } = this.props;
      storeParams();
    }

    render() {
      return (
        <WrappedComponent {...this.props} />
      );
    }
  }

  const mapDispatchToProps = {
    storeParams: () => storeQueryParams()
  };

  return connect(null, mapDispatchToProps)(QueryConsumer);
}


